

import React from 'react'
import NavBar from '../../components/navbar'
import Footer from '../../components/footer'


import ContactSectionPages from '../../components/contact'

function AssistanceofVATPenaltyWaiverPages() {
    return (
        <>
            {/* <NavBar></NavBar> */}

            <section class="about container">

                <div class="row justify-content-center">


                   
                            <h3 class="pb-3 about-h1">Assistance of VAT Penalty Waiver </h3>
                            </div>
                            <p class="about-p1">
                                If a taxpayer is imposed with penalty and if it is unfair, they can petition it with an application that lets the Federal Tax Authority re-assess the decision if it’s not satisfactory. From the day of authorities informing the audit decision to the taxpayer, the latter will be allowed 20 days to file the reconsideration application. It is to be specially noted that the submission for re-assessment will only be valid if it is in Arabic.
                            </p>
                            <p class="about-p1">
                                We at Accruon Consultant lend a hand in amassing and presenting the important files and records necessary for the Reconsideration, taking special care not to surpass the 20 days deadline. We offer profound , can assist you in compiling and submit all the necessary documents required for the Reconsideration within the stipulated time period of 20 business days. We will provide you with in-depth analysis and advices on the complex processes involved in the legal affairs and create an ideal and professional submission with technical and procedural arguments incorporated.
                            </p>

                       

                   
               

            </section >


            <ContactSectionPages></ContactSectionPages>
            {/* <Footer></Footer> */}

        </>
    )
}

export default AssistanceofVATPenaltyWaiverPages